import { useMemo } from 'react';
import { useReportOutletContext } from '@data/pages/ReportLayout/ReportLayout';
import { Drilldown } from '@data/main';
import { resolveMetrics, type MetricRule } from '@data/utils/resolve-metrics';
import { MetricTableType } from '@data/hooks/api/use-metrics-table-v2-api/use-metrics-table-v2-api';
import { AssessmentReportPage } from '@data/components/report/AssessmentReportPage/AssessmentReportPage';

// ── Lexile Report Config ──────────────────────────────────────────────

const PRIMARY_METRICS: MetricRule[] = [
  { metric: 'LEXILE_BOY_ASSESSMENTS_COMPLETE' },
  { metric: 'LEXILE_MOY_ASSESSMENTS_COMPLETE' },
  { metric: 'LEXILE_EOY_ASSESSMENTS_COMPLETE' },
];

// ── Component ──────────────────────────────────────────────────────────────────

export function LexilePage() {
  const { drilldown, productId: edApp } = useReportOutletContext();

  const primaryMetricTypes = resolveMetrics(PRIMARY_METRICS, edApp, drilldown);

  const tableConfig = useMemo(
    () => ({
      metricType:
        drilldown === Drilldown.Class
          ? MetricTableType.IndividualClassLexileAssessments
          : MetricTableType.AllClassLexileAssessments,
      defaultSortColumn: drilldown === Drilldown.Class ? 'STUDENT' : 'CLASS',
      drilldownPath: `/data/${edApp}/lexile-measure/class`,
    }),
    [drilldown, edApp]
  );

  return (
    <AssessmentReportPage
      primaryMetricTypes={primaryMetricTypes}
      proficiencyMetricType="ALL_CLASS_LEXILE_PROFICIENCY"
      proficiencyGraphOptions={{ xFieldKey: 'benchmark' }}
      tableConfig={tableConfig}
    />
  );
}
